import { Navigate } from "react-router-dom";
import { DOCUMENTATION_AREA_ROUTES } from "../Navigation";
import { ReactNode } from "react";
import { useAuth } from "src/apps/hooks/useAuth";

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { token } = useAuth();

  if (!token) {
    return <Navigate to={`${DOCUMENTATION_AREA_ROUTES.LOGIN}${location.search}`} />;
  }

  return <>{children}</>;
};
